import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { AuthGuard } from './guards/auth.guard';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { AuthEffects } from 'app/store/auth/auth.effect';
import { DialogEffects } from 'app/store/global/dialog/dialog.effect';
import { default as authReducer } from 'app/store/auth/auth.reducer';
import { environment } from '@env';
import { TimesheetLogsComponent } from './pages/dashboard/timesheet-logs/timesheet-logs.component';
import { TimesheetComponent } from './pages/dashboard/timesheet/timesheet.component';
import { SnackBarComponent } from './shared/components/snack-bar/snack-bar.component';

import { SelectProjectLocationsDialogComponent } from './shared/components/select-project-locations-dialog/select-project-locations-dialog.component';
import { MessageDialogComponent } from './shared/components/message-dialog/message-dialog.component';
import { ProjectLocationEffects } from './store/project-locations/project-locations.effect';
import { default as projectLocationReducer } from './store/project-locations/project-locations.reducer';
import { PageDetailsLoaderComponent } from './shared/components/details-loader/details-loader.component';
import { TimesheetEffects } from './store/timesheet/timesheet.effect';
import timesheetReducer from './store/timesheet/timesheet.reducer';
import { SharedModule } from './shared/shared.module';
import { AddBreakComponent } from './pages/dashboard/timesheet/add-break/add-break.component';
import { ClockOutDialogComponent } from './pages/dashboard/timesheet/clock-out-dialog/clock-out-dialog.component';
import { AutoLogoutDialogComponent } from './pages/dashboard/timesheet/auto-logout-dialog/auto-logout-dialog.component';
import { ClockNightShiftDialogComponent } from './pages/dashboard/timesheet/clock-night-shift-dialog/clock-night-shift-dialog.component';
import { Page404Component } from './pages/page404/404.component';
import { ForgotIdPinDialogComponent } from './pages/login/forgot-id-pin-dialog/forgot-id-pin-dialog.component';
import { ApiActivityInterceptor } from './interceptors/api-activity.interceptor';
import { CapturePhotoDialog } from './shared/components/capture-photo-dialog/capture-photo-dialog.component';
import { WebcamModule } from 'ngx-webcam';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    TimesheetLogsComponent,
    TimesheetComponent,
    SnackBarComponent,
    SelectProjectLocationsDialogComponent,
    MessageDialogComponent,
    PageDetailsLoaderComponent,
    AddBreakComponent,
    ClockOutDialogComponent,
    AutoLogoutDialogComponent,
    ClockNightShiftDialogComponent,
    Page404Component,
    ForgotIdPinDialogComponent,
    CapturePhotoDialog
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    WebcamModule,
    StoreModule.forRoot({
      auth: authReducer,
      project_locations: projectLocationReducer,
      timesheet: timesheetReducer,
    }),
    !environment.production
      ? StoreDevtoolsModule.instrument({
          maxAge: 25, // number of state changes to keep
          logOnly: environment.production, // restrict extension to log-only mode in prod
        })
      : [],
    EffectsModule.forRoot([
      AuthEffects,
      DialogEffects,
      ProjectLocationEffects,
      TimesheetEffects,
    ]),
    BrowserModule,
    SharedModule,
    AppRoutingModule,
  ],
  providers: [
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiActivityInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
